import "./App.css";
import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import Header from "./components/Header";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import InteractionHistory from "./components/Dashboard/InteractionHistory.jsx";
import Sidebar from "./components/Sidebar";
import { CallActionProvider } from "./utils/context/CallActionContext";
import {
  EmailInbox,
  Chat,
  SocialMedia,
  VoiceCalls,
  Workflow,
  Crm,
  KnowledgeBase,
  CollectionCampaign,
} from "./pages";
import { SelectedCustomerProvider } from "./utils/context/SelectedCustomerContext";
import Reports from "./pages/Reports.jsx";

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  return (
    <div className="relative px-2 pb-4 overflow-x-hidden">
      <Header />

      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        >
          <div
            className={`absolute top-0 left-0 h-full w-[75%] max-w-[260px] bg-black rounded-r-[12px] z-50 flex flex-col sidebar-slide ${
              isSidebarOpen ? "open" : ""
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end p-4">
              <button
                onClick={() => setIsSidebarOpen(false)}
                className="text-xl text-white hover:text-gray-300"
              >
                <AiOutlineClose />
              </button>
            </div>
            <Sidebar closeSidebar={() => setIsSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Mobile Info Panel */}
      {isInfoOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
          onClick={() => setIsInfoOpen(false)}
        >
          <div
            className="absolute top-0 right-0 w-[75%] max-w-[300px] h-full bg-white rounded-l-[12px] z-50 p-3 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end mb-2">
              <button
                onClick={() => setIsInfoOpen(false)}
                className="text-xl text-black hover:text-gray-600"
              >
                <AiOutlineClose />
              </button>
            </div>
            <InteractionHistory />
          </div>
        </div>
      )}

      <div className="flex w-full ">
        {/* Sidebar on desktop */}
        <div className="hidden w-1/5 bg-black md:block rounded-[12px]">
          <Sidebar />
        </div>

        {/* Main content */}
        <div className="w-full pl-4 mt-4 md:w-4/5">
          <Outlet
            context={{
              toggleSidebar: () => setIsSidebarOpen(true),
              toggleInfo: () => setIsInfoOpen(true),
            }}
          />
        </div>
      </div>
    </div>
  );
};

const HomeContent = () => (
  <div className="flex ">
    <div className="w-full md:w-4/5">
      <Dashboard />
    </div>
    <div className="w-1/5 hidden md:flex flex-col border-l    border-[#0000002B]">
      <InteractionHistory />
    </div>
  </div>
);

export default function App() {
  return (
    <SelectedCustomerProvider>
      <CallActionProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomeContent />} />
              <Route path="voice-calls" element={<VoiceCalls />} />
              <Route path="chat" element={<Chat />} />
              <Route path="email-inbox" element={<EmailInbox />} />{" "}
              <Route path="social-media" element={<SocialMedia />} />
              <Route path="workflow-tasks" element={<Workflow />} />
              <Route path="crm" element={<Crm />} />
              <Route path="knowledge-base" element={<KnowledgeBase />} />
              <Route
                path="collection-campaign"
                element={<CollectionCampaign />}
              />
              <Route path="reports" element={<Reports />} />
              {/* <Route path="/upload" element={<UploadCrmCustomers />} /> */}
            </Route>
          </Routes>
        </Router>
      </CallActionProvider>
    </SelectedCustomerProvider>
  );
}
